exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "progress[data-v-0600fbdc]{display:none}.progress-wrapper[data-v-0600fbdc]{--tw-bg-opacity:1;background-color:rgba(233,233,233,var(--tw-bg-opacity));display:flex;align-items:center;height:2.5rem;position:relative;text-align:center;text-align:right;width:100%}.progress[data-v-0600fbdc]{--tw-bg-opacity:1;background-color:rgba(23,22,22,var(--tw-bg-opacity));transition:width .5s ease-in-out;transition-delay:.3s}", ""]);

// exports
